/* eslint-disable */
import {
	useEffect, useMemo, useRef, useState
} from 'react';
import { connect } from 'react-redux';
import { Button, Chip, MenuItem, Select, Tooltip } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
// eslint-disable-next-line object-curly-newline
import moment from 'moment';
import SelectPicker from 'rsuite/SelectPicker';
import {
	filtersInfoChip,
	handleResponseStreamDownload,
	inputHelper,
	usePagination,
	useQuery,
	useSearch,
} from '../../../Helpers';
import { analyticsAction } from '../../../Actions';
import analyticsTypeConstant from '../../../Constants/analyticsType.contants';
import styles from './OrderHistory.module.scss';
import { ListModal } from '../../../Components/Modals';
import SearchBar from '../../../Components/SearchBar/SearchBar';
import Calender from '../../../Components/Forms/Payment Settlements/Calender/Calender';
import OrderHistoryList from './OrdersHistoryList';
import { OrderItemsModal } from '../../../Components/Modals/OrderItemsModal';
import orderAnalyticsServices from '../../../Services/Analytics Services/orderAnalytics.services';
import { notificationServices } from '../../../Services';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { Filter, RefreshCcw } from 'lucide-react';
import GlobalSearch from '@/Components/globalSearch/search';
import drawerActions from '@/Actions/drawer.actions';
import { BackdropLoader } from '@/Components/Loaders';

const ANALYTICS_TYPE = analyticsTypeConstant.ORDER_HISTORY_LIST_DATA;
const PLACE_HOLDERS = {
	ORDER_ID: 'Search by Order Id',
	MOBILE: 'Search by Mobile',
};

const orderTypes = ['REGULAR', 'ADHOC', 'DELIVERY'];

const SEARCH_BY = {
	options: [
		{
			key: 'ORDER_ID',
			title: 'Order ID(UY)',
			get: 'orderId',
		},
		{
			key: 'PARTNER_ORDER_ID',
			title: 'Partner Order ID(UP)',
			get: 'partnerOrderId',
		},
		{
			key: 'PLATFORM_ORDER_ID',
			title: 'Platform Order ID',
			get: 'platformOrderId',
		},
		{
			key: 'MOBILE',
			title: 'Mobile',
			get: 'mobile',
		},
	],
};

const TIME_TYPES = [
	{
		label: 'Order time',
		value: 'ORDER',
	},
	{
		label: 'Scheduled time',
		value: 'SCHEDULED',
	},
];

const ORDER_STATUS = [
	{
		id: 'Order Received',
		title: 'Order Received',
		label: 'Order Received',
		value: 'Order Received',
	},
	{
		id: 'Accepted',
		title: 'Accepted',
		label: 'Accepted',
		value: 'Accepted',
	},
	{
		id: 'Ready For Pickup',
		title: 'Ready For Pickup',
		label: 'Ready For Pickup',
		value: 'READY_FOR_PICKUP',
	},
	{
		id: 'Out For Delivery',
		title: 'Out For Delivery',
		label: 'Out For Delivery',
		value: 'OUT_FOR_DELIVERY',
	},
	{
		id: 'Order Fulfilled',
		title: 'Order Fulfilled',
		label: 'Order Fulfilled',
		value: 'Order Fulfilled',
	},
	{
		id: 'Payment Pending',
		title: 'Payment Pending',
		label: 'Payment Pending',
		value: 'Payment Pending',
	},
	{
		id: 'Order Cancelled / Payment Failed',
		title: 'Order Cancelled / Payment Failed',
		label: 'Order Cancelled / Payment Failed',
		value: 'Order Cancelled / Payment Failed',
	},
	{
		id: 'Refunded',
		title: 'Refunded',
		label: 'Refunded',
		value: 'Refunded',
	},
];

const OrdersHistory = (props) => {
	const {
		fetchData,
		data,
		count,
		dateRangeFilter,
		setDateRangeFilter,
		searchQuery,
		searchBy,
		setQCSearchResults,
		stores,
		permittedStores,
		toggleFiltersDrawer,
	} = props;

	const { page, limit, nextPage, prevPage, setPage } = usePagination({
		customLimit: 10,
	});

	const [countState, setCountState] = useState();
	// eslint-disable-next-line no-unused-vars
	const [timeTypeIndex, setTimeTypeIndex] = useState(0);
	const [selectedOrderStatus, setSelectedOrderStatus] = useState(0);
	const [storeId, setStoreId] = useState('');
	const [search, setSearch] = useState({});
	const filterStateRef = useRef({});
	const [filterValue , setFilterValue] = useState({});
	const [update, setUpdate] = useState(-1);
	const [isRefresh, setIsRefresh] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	let countObj = {};

	useEffect(() => {
		if (count !== null && countObj?.count === undefined) {
			countObj = {
				count,
			};
			setCountState(countObj.count);
		}
	}, [count]);

	const dateRangeFilterArray = useMemo(() => {
		return [
			{
				startDate: dateRangeFilter.from,
				endDate: dateRangeFilter.to,
				key: 'selection',
			},
		];
	}, [dateRangeFilter]);

	const queryParams = useQuery();
	const {
		query,
		handleSearch,
		clearSearch,
		searchBy: searchField,

		handleSearchBy: setSearchField,
	} = useSearch(
		searchQuery,
		SEARCH_BY?.options?.findIndex((option) => {
			return option.key === searchBy;
		}) ?? 0
	);

	const [queryTracker, setQueryTracker] = useState(0);

	const setDate = (newDate) => {
		const { startDate: from, endDate: to } = newDate?.selection ?? {};

		setDateRangeFilter({
			active: true,
			from,
			to,
		});
		if (from != null && to != null) {
			setPage(1);
			const searchKey =
				SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;
			const req = {
				data: {
					mobile: searchKey === 'MOBILE' ? query : '',
					orderId: searchKey === 'ORDER_ID' ? query : '',
					partnerOrderId: searchKey === 'PARTNER_ORDER_ID' ? query : '',
					platformOrderId: searchKey === 'PLATFORM_ORDER_ID' ? query : '',
					dateType: TIME_TYPES[timeTypeIndex]?.value,
					orderStatus: ORDER_STATUS[selectedOrderStatus]?.value,
					storeId,
				},
				params: {
					page,
					limit,
				},
			};
			fetchData(req);
		}
	};

	useEffect(() => {
		if (queryParams.has('clear')) {
			clearSearch();
			setSearchField(0);
			setQCSearchResults('', data, 'ORDER_ID');
		}
	}, [queryParams]);

	const handleSearchBy = (index) => {
		setSearchField(index);
	};

	const handleOrderSearch = (filters, isRefresh = false) => {
		if (
			filters?.dateRange?.from &&
			filters?.dateRange?.to &&
			moment(filters.dateRange.to).diff(moment(filters.dateRange.from), 'days') > 16
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Date must be within 16 days',
			});
			return;
		}
		setIsRefresh(isRefresh);
		setFilterValue(filters);
		setQueryTracker(1);
		setPage(1);
		const searchKey =
			SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;
		const req = {
			data: {
				fromDate: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				toDate: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
				...(isRefresh ? null : {mobile: search?.value === 'MOBILE' ? search?.searchValue : '',
				orderId: search?.value === 'ORDER_ID' ? search?.searchValue : '',
				partnerOrderId: search?.value=== 'PARTNER_ORDER_ID' ? search?.searchValue : '',
				platformOrderId: search?.value === 'PLATFORM_ORDER_ID' ? search?.searchValue : '',
				}),
				variantIds : [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
				dateType: filters?.timeType?.value,
				storeId: filters?.store?.id,
				orderStatus: filters?.status?.[0],
				orderType: filters?.customExclusiveFilters?.id,
				paymentType: filters?.paymentType,
				paymentStatus: filters?.paymentStatus,
			},
			params: {
				page,
				limit,
			},
		};
		fetchData(req);
	};

	const handleTimeTypeChange = (e) => {
		const { fieldValue: index } = inputHelper(e);
		setTimeTypeIndex(index);
		handleOrderSearch({
			dateType: TIME_TYPES[index]?.value,
			orderStatus: ORDER_STATUS[selectedOrderStatus]?.value,
			reqStoreId: storeId,
		});
	};
	const handleOrderStatusChange = (e) => {
		const { fieldValue: index } = inputHelper(e);
		setSelectedOrderStatus(index);
		handleOrderSearch({
			dateType: TIME_TYPES[timeTypeIndex]?.value,
			reqStoreId: storeId,
			orderStatus: ORDER_STATUS[index]?.value,
		});
	};

	const handleOrderHistoryCsv = async (filters) => {
		if (
			filters?.dateRange?.from &&
			filters?.dateRange?.to &&
			moment(filters.dateRange.to).diff(moment(filters.dateRange.from), 'days') > 16
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Date must be within 16 days',
			});
			return;
		}
		setIsLoading(true);
		const searchKey =
			SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;
		const req = {
			data: {
				...filterStateRef?.current,
				fromDate: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				toDate: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
				mobile: searchKey === 'MOBILE' ? query : '',
				orderId: searchKey === 'ORDER_ID' ? query : '',
				partnerOrderId: searchKey === 'PARTNER_ORDER_ID' ? query : '',
				platformOrderId: searchKey === 'PLATFORM_ORDER_ID' ? query : '',
				dateType: filters?.timeType?.value,
				storeId: filters?.store?.id,
				orderStatus: filters?.status?.[0] ?? '',
				orderType: filters?.customExclusiveFilters?.id,
				paymentType: filters?.paymentType,
				paymentStatus: filters?.paymentStatus,
				variantIds : [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
			},
		};
		try {
				const response = await orderAnalyticsServices.downloadCsv({
					req,
				});
				handleResponseStreamDownload(response, `order_history_${moment(
					filters?.dateRange?.from
				).format('YYYY-MM-DD')}-${moment(filters?.dateRange?.to).format(
					'YYYY-MM-DD'
				)}.csv`);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
			} finally {
				setIsLoading(false);
			}
	};

	const BASE_STORES = useMemo(() => {
		const validStores = {};
		permittedStores.forEach((validStoreLoop) => {
			validStores[validStoreLoop.id] = true;
		});
		const tempStore = stores?.filter((storeFilter) => {
			return permittedStores.length === 0 || validStores[storeFilter.id];
		})?.map((tStore) => {
			return {
				id: tStore.id,
				label: tStore?.name ?? '',
				value: tStore.id,
				role: tStore?.type,
				title: tStore?.name ?? '',
				type: tStore?.type,
			};
		});
		tempStore?.unshift({
			id: '',
			value: '',
			label: 'ALL',
			title: 'ALL',
			type: 'ALL',
		});
		return tempStore;
	}, [stores]);

	const handleFiltersState = (filters) => {
		const searchKey = SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;
		filterStateRef.current = {
			from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
			mobile: searchKey === 'MOBILE' ? query : '',
			orderId: searchKey === 'ORDER_ID' ? query : '',
			partnerOrderId: searchKey === 'PARTNER_ORDER_ID' ? query : '',
			platformOrderId: searchKey === 'PLATFORM_ORDER_ID' ? query : '',
			dateType: filters?.timeType?.value,
			storeId: filters?.store?.id,
			orderStatus: filters?.status?.[0] ?? '',
			orderType: filters?.customExclusiveFilters?.id,
			variantIds : [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
		};
	};

	const reqOptions = useMemo(() => {
		const searchKey =
			SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;

		return {
			data: {
				fromDate: moment(filterStateRef?.current?.from).format(
					'YYYY-MM-DD'
				),
				toDate: moment(filterStateRef?.current?.to).format(
					'YYYY-MM-DD'
				),
				mobile: searchKey === 'MOBILE' ? query : '',
				orderId: searchKey === 'ORDER_ID' ? query : '',
				partnerOrderId: searchKey === 'PARTNER_ORDER_ID' ? query : '',
				platformOrderId: searchKey === 'PLATFORM_ORDER_ID' ? query : '',
				...filterStateRef?.current,
			},
			params: {
				page,
				limit,
			},
		};
	}, [searchField, page, limit]);

	const dropDownItems = [
		{
			label: 'Order ID',
			value: 'ORDER_ID',
			placeholder: 'Search by Order ID',
			getData: true,
		},
		{
			label: 'Partner Order ID',
			value: 'PARTNER_ORDER_ID',
			placeholder: 'Search by Partner Order ID',
			getData: true,
		},
		{
			label: 'Platform Order ID',
			value: 'PLATFORM_ORDER_ID',
			placeholder: 'Search by Platform Order ID',
			getData: true,
		},
		{
			label: 'Mobile',
			value: 'MOBILE',
			placeholder: 'Search by Mobile',
			getData: true,
		},
	];
	useEffect(() => {
		if(search?.keyPress && search?.searchValue?.trim() === '') {
			handleOrderSearch(filterValue);
		}
	}, [search?.searchValue]);

	const handleCall = (e) => {
		if(e.key === 'Enter') {
			handleOrderSearch();
		}
	}
	
	const filtersInfo = {
		header : {
			store : false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		filteredStore : {
			text : 'Order at',
			show: true,
		},
		status : {
			text : 'Order Status',
			show: true,
		},
		customExclusiveFilters : {
			text : 'Order Type',
			show: true,
			singleSelect: true,
			filterList: orderTypes?.map((ele) => ({
						value: ele,
						label: ele,
				})),
		},
		paymentType : {
			text : 'Payment Type',
			show: false,
			list : [
				{
					label : 'CASH',
					type: 'CASH'
				},
				{
					label : 'DIGITAL',
					type: 'DIGITAL'
				},
				{
					label : 'WALLET',
					type: 'WALLET'
				},
				{
					label : 'AGGREGATOR',
					type: 'AGGREGATOR'
				}
			]
		},
		paymentStatus : {
			text : 'Payment Status',
			show: false,
			list : [
				{
					label : 'PENDING',
					type: 'PENDING'
				},
				{
					label : 'USER PENDING',
					type: 'USER_PENDING'
				},
				{
					label : 'TXN SUCCESS',
					type: 'TXN_SUCCESS'
				},
				{
					label : 'PAYTM PENDING',
					type: 'PAYTM_PENDING'
				},
				{
					label : 'TXN FAILURE',
					type: 'TXN_FAILURE'
				},	
			]
		},
		dateRange : {
			text : 'Order Date',
			show: true,
		},
		timeType : {
			text : 'Date Time Type',
			show : true,
		},
		productWithVariants:{
			text: 'Product',
			show: true,
		},
	}

	const exportInfo = {
		showExportBtn : true,
	};

	return (
		<div className={styles.root}>
		<BackdropLoader isLoading={isLoading} showProgress={true}/>
			<OrderItemsModal />
			<ListModal selectionBehaviour='SHOW' />
			<div className='p-2'>
				<ImagesFinder
					onSubmit={handleOrderSearch}
					update={update}
					statusList={ORDER_STATUS}
					timeTypeArray={TIME_TYPES}
					onUpdate={handleFiltersState}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
				<div className='flex justify-between items-center w-full p-4'>	
						<span className='font-bold text-[16px]'>Customer Order List</span>
				</div>
				<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className='w-[82%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip title='Refresh Customer Orders'>
					<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
						handleOrderSearch(filterValue, true);
					}} />
				</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								handleDataExport: (req) => handleOrderHistoryCsv(req),
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filterValue)}
			{/* <div className={styles.header}>
				<div className={styles['search-container']}>
					<SearchBar
						value={query}
						placeholder={PLACE_HOLDERS[searchField]}
						handleInput={handleSearch}
						handleChange={handleSearchBy}
						// onChange={onChange}
						searchBy={
							SEARCH_BY != null
								? {
									...(SEARCH_BY ?? {}),
									current:
										searchField === -1
											? 0
											: searchField,
								}
								: null
						}
						className={styles.search}
						showBtn
						handleOrderSearch={handleOrderSearch}
					/>
					<Select
						className={styles['order-status']}
						value={selectedOrderStatus}
						onChange={handleOrderStatusChange}
					>
						{ORDER_STATUS?.map((option, idx) => {
							const { title } = option;
							return (
								<MenuItem value={idx} key={title}>
									{title}
								</MenuItem>
							);
						})}
					</Select>
				</div>
				<div>
					<SelectPicker
						data={BASE_STORES}
						style={{
							width: 224,
						}}
						groupBy='type'
						placeholder='Select Store'
						onChange={(id) => {
							setStoreId(id);
							handleOrderSearch({
								dateType: TIME_TYPES[timeTypeIndex]?.value,
								reqStoreId: id,
								orderStatus:
									ORDER_STATUS[selectedOrderStatus]?.value,
							});
						}}
						renderMenuItem={(_, item) => {
							return (
								<div>
									<i className='rs-icon rs-icon-user' />
									{' '}
									{_}
								</div>
							);
						}}
						cleanable={false}
						renderMenuGroup={(_, item) => {
							return (
								<div>
									<i className='rs-icon rs-icon-group' />
									{_}
								</div>
							);
						}}
						value={storeId}
						renderValue={(value, item) => {
							const selectedItem = BASE_STORES.find((ele) => {
								return ele?.value === storeId;
							});
							return (
								<div className='rsuite-select-picker-render-value'>
									{'Store: '}
									{selectedItem?.label}
								</div>
							);
						}}
					/>
				</div>
				<div className={styles.dateFilter}>
					<div className={styles.dateType}>
						<Select
							className={styles['search-by']}
							value={timeTypeIndex}
							onChange={handleTimeTypeChange}
						>
							{TIME_TYPES?.map((option, idx) => {
								const { title } = option;
								return (
									<MenuItem value={idx} key={title}>
										{title}
									</MenuItem>
								);
							})}
						</Select>
					</div>
					<Calender
						value={dateRangeFilterArray}
						allowFutureDates
						setValue={setDate}
					/>
				</div>
			</div> */}
			<OrderHistoryList
				page={page}
				limit={limit}
				nextPage={nextPage}
				prevPage={prevPage}
				setPage={setPage}
				storeId={storeId}
				data={data}
				timeType={TIME_TYPES[timeTypeIndex]?.value}
				orderStatus={ORDER_STATUS[selectedOrderStatus]?.value}
				ANALYTICS_TYPE={ANALYTICS_TYPE}
				listCount={countState}
				SEARCH_BY={SEARCH_BY}
				searchField={searchField}
				query={query}
				fetchData={fetchData}
				queryTracker={queryTracker}
				// handleOrderHistoryCsv={handleOrderHistoryCsv}
				reqOptions={reqOptions}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { LIST_DATA: data } = state.analytics.ORDER_HISTORY;
	const stores = state?.form?.STORES?.data?.LIST;
	const count = data ? data.recordCount : 0;
	const { query: searchQuery, searchBy } =
		state.analytics.ORDER_HISTORY.SEARCH_DATA;
	const { permittedStores } = state.navigation;
	return {
		stores,
		dateRangeFilter,
		data: data?.orders,
		count,
		searchQuery,
		searchBy,
		permittedStores,
	};
};
const mapDispatchToProps = {
	setAnalyticsType: analyticsAction.setAnalyticsType,
	fetchData: analyticsAction.fetchData,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	setQCSearchResults: analyticsAction.setQCSearchResults,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersHistory);
